import _ from 'lodash';
import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';
import { TABLE_UNMOUNT } from '../Table/tableActions';

// Action Types
export const APPLICATIONS_LOAD = 'LEAD_TO_LIVE/APPLICATIONS_LOAD';
export const APPLICATIONS_SUCCESS = 'LEAD_TO_LIVE/APPLICATIONS_SUCCESS';
export const APPLICATIONS_FAILURE = 'LEAD_TO_LIVE/APPLICATIONS_FAILURE';

const initialState = {
    applications: [],
    loading: false,
    error: null,
    count: 0,
    pages: 0,
    hasMore: false,
    offset: 0,
    limit: 0
};

export default function reducer(state = initialState, action = {}) {
    let newState;
    switch (action.type) {
        case TABLE_UNMOUNT:
            newState = {
                ...state,
                applications: []
            };

            return _.isEqual(state, newState) ? state : newState;

        case APPLICATIONS_LOAD:
            newState = {
                ...state,
                applications: [],
                error: null,
                loading: true
            };

            return _.isEqual(state, newState) ? state : newState;

        case APPLICATIONS_SUCCESS:
            newState = {
                ...state,
                applications: action.applications || [],
                count: action.count || 0,
                loading: false,
                error: null,
                pages: action.pages || 0,
                hasMore: action.hasMore || false,
                offset: action.offset || state.offset,
                limit: action.limit || state.limit
            };

            return _.isEqual(state, newState) ? state : newState;

        case APPLICATIONS_FAILURE:
            newState = {
                ...state,
                applications: [],
                count: 0,
                error: action.error,
                loading: false,
                pages: 0
            };

            return _.isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getApplicationsEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'applications')
);

export const getApplications = createSelector(
    getApplicationsEntity,
    (entity) => _.get(entity, 'applications')
);

export const getIsApplicationsLoading = createSelector(
    getApplicationsEntity,
    (entity) => _.get(entity, 'loading')
);

export const getApplicationsError = createSelector(
    getApplicationsEntity,
    (entity) => _.get(entity, 'error')
);

export const getApplicationsErrorMessage = createSelector(
    getApplicationsError,
    (error) => _.get(error, 'message')
);

export const getApplicationsPages = createSelector(
    getApplicationsEntity,
    (entity) => _.get(entity, 'pages')
);

export const getApplicationsCount = createSelector(
    getApplicationsEntity,
    (entity) => _.get(entity, 'count')
);

export const getApplicationsHasMore = createSelector(
    getApplicationsEntity,
    (entity) => _.get(entity, 'hasMore')
);

